// src/context/language/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import i18n from "../../locale/i18n";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en");
  const [direction, setDirection] = useState("ltr");

  useEffect(() => {
    const storedLang = localStorage.getItem("language");
    if (storedLang) {
      setLanguage(storedLang);
      i18n.changeLanguage(storedLang);
      const dir = storedLang === "ar" ? "rtl" : "ltr";
      setDirection(dir);
      document.documentElement.dir = dir;
      document.documentElement.setAttribute('lang', storedLang);
      document.body.setAttribute("direction", dir);
      document.body.dir = dir;
    }
  }, []);

  const toggleLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("language", lang);
    i18n.changeLanguage(lang);
    const dir = lang === "ar" ? "rtl" : "ltr";
    setDirection(dir);
    document.documentElement.dir = dir;
    document.documentElement.setAttribute('lang', lang);
    document.body.setAttribute("direction", dir);
    document.body.dir = dir;
  };

  return (
    <LanguageContext.Provider value={{ language, direction, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);